export default {
  LIST: {
    TITLE: `Schedule templates`,
    SUMMARY: ``
  },
  LIST_PROJECT: {
    TITLE: `{{ project }} schedule templates`,
    SUMMARY: `Only template belonging to the selected project are visible on this page, go to the main schedule templates page to view others.`
  },
  LIST_PROJECT_SIMPLE: {
    TITLE: `{{ project }} schedule templates`,
    SUMMARY: ``
  },
  CREATE: `Create a schedule template`,
  APPLY: `Apply to schedule`,
  COPY: `Copy`,
  DUPLICATE: `Duplicate`,
  EMPLOYEE_SELECTION_TOOL: `Employee selection tool`,

  SAVE: `Save shifts`,
  DAY_HEADER: `Day {{ multiDayIndex }}`,
  NUMBER_OF_DAYS: `Single day template`,
  NUMBER_OF_DAYS_other: `{{ count }} day template`,
  EVENT_SUMMARY: `<0>{{ name }}</0> - {{ positionName }} <1>(Day {{ multiDayIndex }}, {{ start }} - {{ end }})</1>`,
  SELECT_ALL: `Select all`,
  UNSELECT_ALL: `Unselect all`,
  TEMPLATE_DELETED: `Template was deleted`,
  ARCHIVED: `Archived`,
  ARCHIVE: `Archive`,
  UNARCHIVE: `Unarchive`,
  IMPORT_SCHEDULE_TEMPLATE: `Import schedule template`,
  form: {
    EDIT: {
      TITLE: `Edit the schedule template ({{ name }})`,
      SUMMARY: ``
    },
    CREATE: {
      TITLE: `Create the schedule template`,
      SUMMARY: ``
    },
    OPTIONS: `Options`,
    MULTI_CREATION: `Create multiple`,
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter a name`,
      DESCRIPTION: `Used to identify the template`
    },
    COMMENT: {
      LABEL: `Comment`,
      PLACEHOLDER: `Enter a comment`,
      DESCRIPTION: `Used to add context to this template`
    },
    REQUIREDPOSITIONS: {
      LABEL: `Required positions`,
      PLACEHOLDER: `Select one or more positions`,
      DESCRIPTION: `Used to determine which positions can hold shifts in this template as well as which positions are visible when editing the template.`
    },
    DEFAULTSHIFTCOMMENT: {
      LABEL: `Default shift comment`,
      PLACEHOLDER: `Enter a comment`,
      DESCRIPTION: `Used to set the default comment on each shift unless a comment is added to an individual shift. This field supports translations using #fr and #en.`
    },
    DEFAULTSHIFTTAGS: {
      LABEL: `Default shift tags`,
      PLACEHOLDER: `Select one or more tags`,
      DESCRIPTION: `Used to set the default shift tags when none are added to a shift.`
    },
    COMBINESHIFTANDTEMPLATETAGS: {
      LABEL: `Combine default shift tags and individual shift tags`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If active, when default shift tags and individual shift tags are defined, all sets of tags will be assigned to the shift, including projets.`
    },
    DEPARTMENTS: {
      LABEL: `Departments`,
      PLACEHOLDER: `Select one or more departments`,
      DESCRIPTION: `Used to indicate which departments this template belongs to.`
    },
    ALLSHIFTSIRREPLACEABLE: {
      LABEL: `All shifts are irreplaceable`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If active, all shifts applied to the schedule from this template will be marked as irreplaceable.`
    },
    MULTIDAYINDEX: {
      LABEL: `Day in template`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Used to move the shift from one day in the template to another.`,
      OPTION: `Day {{ day }}`
    },
    NUMBEROFIDENTICAL: {
      LABEL: `Number of identical shifts`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Used to create multiple identical shifts, if 5 is entered above, 5 identical shifts will be added to the template rather than one.`
    },
    ADDTOOTHERDAYS: {
      LABEL: `Add to other days`,
      PLACEHOLDER: `Select other days`,
      DESCRIPTION: `Used to create a similar shift on multiple days of the template, can be combined with number of identical shifts to create multiple shifts on multiple days.`
    },
    PROJECTS: {
      LABEL: `Project`,
      PLACEHOLDER: `Select a project`,
      DESCRIPTION: `Used to indicate whether a template is part of a project, this will hide it from the main template list unless the project is searched directly. This will also link any shifts created by this template to the select project.`
    },
    TEAM: {
      LABEL: `Team`,
      PLACEHOLDER: `Select a team`,
      DESCRIPTION: `Used to indicate whether a template is part of a team. This will link any shifts created by this template to the select team.`
    },
    BULK_SHIFT_CREATE: {
      TITLE: `Bulk shift creation`,
      NO_REQUIRED_POSITIONS: `There are no required positions in this template, add some to use the bulk shift creation tool.`,
      BULKSTARTTIME: {
        LABEL: `Start time`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Used to create shifts using a specific start time.`
      },
      BULKENDTIME: {
        LABEL: `End time`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Used to create shifts using a specific end time.`
      },
      AMOUNT: {
        LABEL: `Amount`,
        PLACEHOLDER: ``,
        DESCRIPTION: ``
      },
      BULKSCHEDULETYPE: {
        LABEL: `Schedule type`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Used to quickly select a pre-defined schedule type.`
      }
    },
    FIELD_MANDATORY: `This field is required.`
  },
  DATES_MODAL: {
    TITLE: `Dates detail for template`,
    SUMMARY: `Shows what shifts from this template are applied to the schedule.`,
    POSITION_DETAIL_other: `<0>{{ count }}</0> shifts at <0>{{ positionName }}</0>`,
    POSITION_DETAIL: `<0>{{ count }}</0> shift at <0>{{ positionName }}</0>`
  },
  IMPORT_FROM_SCHEDULE: `Import shifts from the schedule`,
  IMPORT_SCHEDULE_MODAL: {
    TITLE: `Import shifts`,
    SUMMARY: `Used to import shifts from a specific date in the schedule.`,
    DESCRIPTION: `Only shifts belonging to the required positions of this template will be imported.`,
    ERROR_IMPORTING: `Error importing shifts, please try again.`,
    DATE: {
      LABEL: `Date`,
      PLACEHOLDER: `Please select a date.`,
      DESCRIPTION: `The date in the schedule you would like to import from.`
    },
    KEEPASSIGNEDEMPLOYEES: {
      LABEL: `Keep assigned employees`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If inactive, employees will be removed from the shifts before importing into the template.`
    },
    IMPORTONLYFROMTHISTEMPLATE: {
      LABEL: `Import only from this template`,
      PLACEHOLDER: ``,
      DESCRIPTION: `If active, shifts that belong to other templates will be ignored.`
    }
  },
  employeeSelectionTool: {
    USE: `Use employee selection tool`,
    MODAL: {
      TITLE: `Employee selection tool`,
      SUMMARY: `Used to get lists of employees based on filters to help populate the template.`
    },
    form: {
      FILTERELIGIBLEEMPLOYEES: {
        LABEL: `Show eligible employees only`,
        DESCRIPTION: ``
      },
      DATESTOCHECK: {
        LABEL: `Dates to check for issues`,
        PLACEHOLDER: `Please select at least one date`,
        DESCRIPTION: `Used to determine which dates to check when looking at time off, other shifts, and other date related issues.`
      },
      ATTRIBUTES: {
        LABEL: `Attributes`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Used to filter employees that have specific requirements and skills and do not have certain restrictions.`
      },
      REGIONS: {
        LABEL: `Regions`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Used to filter employees by their region.`
      },
      PROJECTS: {
        LABEL: `Projects`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Used to filter employees by the projects they are part of.`
      },
      SELECTEDSORT: {
        LABEL: `Sort order to use`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Used to sort the employees based on a pre-determined sort order.`
      },
      SELECTEDFILTER: {
        LABEL: `Filter to use`,
        PLACEHOLDER: ``,
        DESCRIPTION: `Used to filter the employees based on a pre-determined filter configuration.`
      }
    },
    TOO_MANY_USERS_SELECTED: `You have selected more employees than available shifts, the last few you selected won't be assigned.`,
    SOME_SHIFTS_ASSIGNED: `Some shifts already had employees assigned to them, they will be replaced.`,
    LOAD_EMPLOYEES: `Load employees`,
    ELIGIBLE: `Eligible`,
    NOT_ELIGIBLE: `Not eligible`,
    LOCKED_TO_CURRENT_PROJECT: `Locked to current project`,
    LOCKED_TO_OTHER_PROJECT: `Locked to another project`,
    PREFERRED_CURRENT_PROJECT: `Preferred on current project`,
    PREFERRED_OTHER_PROJECT: `Preferred on other project`,
    INVALID_EMPLOYEE_STATUS: `Invalid employee status`,
    INVALID_EMPLOYEE_TYPE: `Invalid employee type`,
    UNAVAILABLE: `Not available all day`,
    UNAVAILABLE_RANGE: `Not available from {{ start }} to {{ end }}`,
    AVAILABLE_RANGE: `Available from {{ start }} to {{ end }}`,
    PREFERRED_RANGE: `Prefers working from {{ start }} to {{ end }}`,
    EVENT_OVERLAPPING: `Already scheduled to {{ positionName }} from {{ start }} to {{ end }}`,
    EVENT_OVERLAPPING_PROJECT: `Already scheduled to {{ positionName }} from {{ start }} to {{ end }} on project {{ projectName }}`,
    ASSIGN_EMPLOYEES: `Assign selected employees`,
    ALREADY_IN: `Already assigned in template`,
    UNASSIGNED_SHIFTS: `Unassigned shifts`,
    ASSIGNED_SHIFTS: `Assigned shifts`,
    ALREADY_IN_MULTI: `Already assigned to day {{ days }} in template`,
    ALREADY_IN_MULTI_other: `Already assigned to days {{ days }} in template`,
    ISSUES: `Issues`,
    VIEW_LESS: `View less issues`,
    VIEW_MORE: `View {{ count }} other issue`,
    VIEW_MORE_other: `View {{ count }} other issues`,
    PROJECT_EXPERIENCE: `Experience on project: {{ totalProjectExperience }}h`,
    RELATED_PROJECT_EXPERIENCE: `Experience on related projects: {{ totalRelatedProjectExperience }}h`
  },
  EDIT_TEMPLATE_INFO: `Edit template info`,
  TEMPLATE_INFO_MODAL: {
    TITLE: `Edit template info`,
    SUMMARY: `Used to set default info for all shifts in template as well as some of the template's properties.`
  },
  DELETE_BUTTON: {
    TITLE: `Delete this template`,
    SUMMARY: `Are you sure you want to delete this template?`,
    PRIMARY_ACTION: `Delete`
  },
  SCHEDULE_TEMPLATE_APPLY_MODAL: {
    TITLE: `Apply schedule template`,
    SUMMARY: ``
  },
  CONTEXT_MENU: {
    EDIT: `Edit`,
    DELETE: `Delete`,
    REMOVE_EMPLOYEE: `Unassign employee`,
    TOGGLE_OVERTIME: `Toggle overtime status`,
    TOGGLE_VARIABLE_END_TIME: `Toggle the variable end time status`,
    EMPLOYEE_SELECTION_TOOL: `Fill with employee selection tool`,
    SELECTED: `{{ count }} shift selected`,
    SELECTED_other: `{{ count }} shifts selected`
  },
  applyForm: {
    MULTI_SELECT: `Multi-select dates`,
    LOAD_DATES: `Add to dates to apply field`,
    LOAD_APPLIED_DATES: `Load dates this template is already applied to`,
    REMOVE_ALL_DATES: `Clear all dates`,
    FINE_TUNE: `Fine tune dates`,
    ERROR_APPLYING_TEMPLATE: `There was an error while trying to apply this template.`,
    NUMBER_OF_DATES_SELECTED_PAST: `You have selectd {{ count }} date in the past without disabling the option to only apply on future dates.`,
    NUMBER_OF_DATES_SELECTED_PAST_other: `You have selectd {{ count }} dates in the past without disabling the option to only apply on future dates.`,
    NEW_DATES: `{{ count }} new date will be applied to the schedule.`,
    NEW_DATES_other: `{{ count }} new dates will be applied to the schedule.`,
    MODIFIED_DATES: `{{ count }} existing date will be modified on the schedule.`,
    MODIFIED_DATES_other: `{{ count }} existing dates will be modified on the schedule.`,
    DELETED_DATES: `{{ count }} existing date will be deleted from the schedule.`,
    DELETED_DATES_other: `{{ count }} existing dates will be deleted from the schedule.`,
    DATESTOAPPLY: {
      LABEL: `Dates to apply`,
      PLACEHOLDER: `Select some dates`,
      DESCRIPTION: `Used to select what dates this template will be applied to, creating or modifying shifts.`
    },
    MODIFIEDDATES: {
      LABEL: `Modified dates`,
      PLACEHOLDER: `No dates to modify selected`,
      DESCRIPTION: `Allows fine tuning dates that will be modified when the template is applied.`
    },
    DELETEDDATES: {
      LABEL: `Deleted dates`,
      PLACEHOLDER: `No dates to delete selected`,
      DESCRIPTION: `Allows fine tuning dates that will be deleted when the template is applied.`
    },
    NEWDATES: {
      LABEL: `New dates`,
      PLACEHOLDER: `No new dates selected`,
      DESCRIPTION: `Allows fine tuning dates that will be added when the template is applied.`
    },
    MULTISELECTRANGE: {
      LABEL: `Multi-select range`,
      PLACEHOLDER: `Select a range`,
      DESCRIPTION: `Determines the period over which dates will be selected in the dates to apply.`
    },
    MONDAY: { LABEL: `Mon` },
    TUESDAY: { LABEL: `Tue` },
    WEDNESDAY: { LABEL: `Wed` },
    THURSDAY: { LABEL: `Thu` },
    FRIDAY: { LABEL: `Fri` },
    SATURDAY: { LABEL: `Sat` },
    SUNDAY: { LABEL: `Sun` },
    DAY_OF_WEEK_DESCRIPTION: `Determines which days of the week will be selected.`,
    DELETESHIFTS: {
      LABEL: `Delete shifts`,
      DESCRIPTION: `Used to delete shifts rather than add them, will delete all shifts from this template on selected days.`
    },
    APPLYINFUTURE: {
      LABEL: `Apply only future shifts`,
      DESCRIPTION: `Used to apply shifts to dates in the future, if active only dates in the future will be affected.`
    },
    DONTUPDATEUSERS: { LABEL: `Don't update users`, DESCRIPTION: `` },
    DONTUPDATETAGS: { LABEL: `Don't update tags`, DESCRIPTION: `` },
    DONTUPDATECOMMENTS: { LABEL: `Don't update comments`, DESCRIPTION: `` },
    DONTUPDATETIME: { LABEL: `Don't update times`, DESCRIPTION: `` }
  },
  MULTI_DAY: `Multi-day`,
  NAME: `Name`,
  COMMENT: `Comment`,
  TEAM: `Team`,
  DEFAULTSHIFTCOMMENT: `Default shift comment`,
  CREATEDBY: `Created by`,
  CREATIONDATE: `Created on`,
  LASTUPDATEBY: `Last updated by`,
  LASTUPDATEDATE: `Last updated on`,
  DEFAULTSHIFTTAGS: `Default shift tags`,
  DEPARTMENTS: `Departements`,
  REQUIREDPOSITIONS: `Required positions`,
  SHIFTS: `Shifts`,
  ALLSHIFTSIRREPLACEABLE: `All shifts irreplaceable`,
  APPLIED_FROM: `Applied from {{ firstDate }} to {{ lastDate }}`,
  NOT_APPLIED: `Not applied to the schedule`,
  import: {
    TITLE: `Import schedule template`,
    SUMMARY: ``,
    TEMPLATE_FIELDS: `Template import fields`,
    TEMPLATE_EVENT_FIELDS: `Template event import fields`,
    FILENAME: `schedule_template_import`,
    NAME: `Name`,
    NAME_DESC: `Name that the template will have.`,
    PROJECTCODE: `Project`,
    PROJECTCODE_DESC: `Must be an existing project.`,
    DEFAULTSHIFTTAGS: `Default shift tags`,
    DEFAULTSHIFTTAGS_DESC: `Must be a list of existing tags codes. To enter more than one value leave a space between each code.`,
    DEPARTMENTS: `Departments`,
    DEPARTMENTS_DESC: `Must be a list of existing departments. To enter more than one value leave a space between each code.`,
    REQUIREDPOSITIONS: `Required positions`,
    REQUIREDPOSITIONS_DESC: `Must be a list of existing position codes. To enter more than one value leave a space between each code.`,
    COMMENT: `Comment`,
    COMMENT_DESC: `A comment that describes the template`,
    DEFAULTSHIFTCOMMENT: `Default shift comment`,
    DEFAULTSHIFTCOMMENT_DESC: `A comment that will be added to every shift in the template. Inserting a '<0>X</0>' in the cell means <0>YES</0>, leaving in empty means <0>NO</0>.`,
    ALLSHIFTSIRREPLACEABLE: `All shifts irreplaceable`,
    ALLSHIFTSIRREPLACEABLE_DESC: `Whether or not all shifts are irreplaceable (Same instructions as <0>defaultShiftComment</0>).`,
    COMBINESHIFTANDTEMPLATETAGS: `Combine shift and template tags`,
    COMBINESHIFTANDTEMPLATETAGS_DESC: `Whether or not to combine shift and template tags (Same instructions as <0>defaultShiftComment</0>).`,
    STARTTIME: `Start time`,
    STARTTIME_DESC: `Start time in <1>HH:mm</1> format, for example 8AM would be <1>08:00</1>.`,
    ENDTIME: `End time`,
    ENDTIME_DESC: `End time in <1>HH:mm</1> format, for example  5PM would be <1>17:00</1>.`,
    DAYINTEMPLATE: `Day in template`,
    DAYINTEMPLATE_DESC: `If the template has multiple days, indicates the day in the template that the shift belongs to.`,
    VALIDATION: `Validation`
  }
}
